import { View } from 'es6/components/view'
import { Popup } from 'es6/libs/popup'
import { isMobile } from 'init/is-mobile'
import $ from 'init/jquery'
import { Defaults } from 'es-decorators'

/**
 * Вид для кнопки инициализации модального окна в разделе контактов (/kontakty/managers/).
 */

@Defaults({
  additionalOptions: ['countryFlag'],
})
export class ManagerContactsPopupView extends View {
  /**
   * @inheritDoc
   */
  run () {
    let opener = this.$el.data('open'),
      popup = $('[data-open-popup="' + opener + '"]')
    this.canClosePopup = true

    this.initPopup(popup, this.$el)

    /**
     * Иногда не нужно закрывать окно popup при наступлении стандартных событий, например,
     * если в одном popup размещен другой элемент popup (форма задания вопроса в разделе контактов).
     */
    this.popup.addEventListener(
      Popup.EventType.AFTER_CLOSE, () => {
        if (!this.canClosePopup) {
          this.popup.open()
          this.canClosePopup = true
        }
      }
    )

    this.listenTo(this.countryFlag, 'change', this.choiceCountry)
  }
  /**
   * Инициализирует попап
   * @param {jQuery} popup
   * @param {jQuery} opener
   * @param {Object} [css]
   */
  initPopup (popup, opener, css) {
    this.popup = new Popup(popup, opener)
    this.popup.addEventListener(
      Popup.EventType.BEFORE_OPEN, () => {
        let width = this.getPopupSize(),
          offsetLeft = this.$el.parent().offset().left - (width - this.$el.parent().width()) / 2,
          offsetTop = this.$el.offset().top + this.$el.innerHeight() + 10,
          body = $('body')
        if (isMobile) {
          offsetLeft = (body.width() - width) / 2
          offsetTop = offsetTop - body.position().top
        }
        css = {
          left: offsetLeft,
          top: offsetTop,
          width: width,
        }
        popup.css(css)
        if (opener.data('manager_id')) {
          $('#' + opener.data('open') + ' [name=manager_id]').val(opener.data('manager_id'))
        }
      }
    )
  }
  /**
   * Определение размеров для элемента.
   * @returns {number}
   */
  getPopupSize () {
    let width = 320,
      minWidth = 230

    if (this.$el.parent().width() < 320) {
      width = this.$el.parent().width() - minWidth >= 0
        ? this.$el.parent().width()
        : minWidth
    }
    if (isMobile) {
      width = 296
    }
    return width
  }
  /**
   * При выборе пользователем страны устанавливаем флаг.
   */
  choiceCountry () {
    this.canClosePopup = false
  }
}
